function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(function() {
    var clearBtns = document.querySelectorAll('.js-clear-form__input');

    clearBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            var form = btn.form;
            var checkboxes = form.querySelectorAll('input[type="checkbox"]');
            // var radios = form.querySelectorAll('input[type="radio"]');
            var ranges = form.querySelectorAll('input[type="range"]');
            var activeValues = form.querySelectorAll('.js-clear-form__active-values');
            var itemsCount = form.querySelectorAll('.fls-filter__option-count');

            form.reset();

            checkboxes.forEach(function(checkbox) {
                checkbox.checked = false;
                checkbox.disabled = false;
            });

            ranges.forEach(function(range) {
                var defaultValue = range.getAttribute("placeholder");
                range.value = defaultValue;
                slideOne();
                slideTwo();
            });

            activeValues.forEach(function(activeValue) {
                activeValue.innerHTML = '';
            });

            itemsCount.forEach(function(itemCount) {
                itemCount.style.opacity = '.25';
            });
        });
    });
});